import { Routes } from '@angular/router';
import { authGuardFn } from '@auth0/auth0-angular';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'board',
  },
  {
    path: 'board',
    canActivate: [authGuardFn],
    loadComponent: () => import('./features/board/feature/board-shell').then((m) => m.BoardShell),
  },
  {
    path: 'board-mobile',
    canActivate: [authGuardFn],
    loadComponent: () =>
      import('./features/board/feature/board-mobile-page').then((m) => m.BoardMobilePage),
  },
  {
    path: '**',
    redirectTo: 'board',
  },
];
